<template>
  <div
    :class="{
      dialogEnabled: dialogEnabled,
      rubyEnabled: rubyEnabled,
      messageEnabled: messageEnabled,
      fixedMessage: fixedMessage
    }"
  >
    <div class="your-yagi">
      <div class="message-placement" v-if="messageEnabled">
        <div class="fixed message" v-if="fixedMessage">
          {{ fixedMessage }}
        </div>
        <div class="message" v-else-if="message && messageEnabled">
          {{ message }}
        </div>
      </div>
      <div class="image-area" @click="openDialog">
        <ruby title="なまえをかえられるよ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 60"
            width="80"
            height="80"
          >
            <path
              d="M52.4,35.7c0.2-1,1.9-5.2,2.3-6c1.3-2.4,1.7-5.8-0.4-8.2c-1.2-1.5-3-2.4-5-2.4
            c-0.3,0-0.6,0-0.9,0.1c-2.5,0.2-4.7,1.8-6.1,3.6c-0.8,1-5.2,8.9-4.6,12.7l0,0c0,0,0,0,0,0l0,0c0,0,0,0.1,0,0.1l0,0
            c0.2,1.1,0.6,2.1,1.3,3.1c3.2,4.2,5.1,4.3,6.4,7.1c0,0,0,0,0,0c0.1,0.2,0.2,0.4,0.3,0.5c1.2,3,0.2,3.7,0.5,4.5
            c0,0.1,0.1,0.2,0.1,0.2c0,0.1-0.1,0.3-0.1,0.4l0,0l-0.3,1.7c-2.4,0.2-1.6,2.8-1.6,2.8c0.2,0.5,3.7,0.1,4.3,0.1l1.4-1.4l1.3-0.8
            c0.7-0.6,0.5-1.5,0.2-1.9l-0.3-1l0,0c0-0.1,0-0.1-0.1-0.2c0.2-0.6,0.6-1.8,1.6-2.9c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1
            c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0,0,0,0c1-0.9,1.6-2.2,1.6-3.6c0-0.8-0.2-1.5-0.5-2.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0
            c0-0.1-0.1-0.2-0.1-0.3c-0.4-0.7-0.7-1-1.2-1.9c-0.6-1.2-0.7-2.5-0.5-3.6l0,0C52.4,35.8,52.4,35.8,52.4,35.7L52.4,35.7z"
              style="fill: #eeedee"
            />
            <path
              d="M48.2,56.2L48.2,56.2c0-0.1-0.1-1-0.7-1.7c-0.6-0.6-1.3-0.9-1.4-0.9l-0.3-0.4
            c-2.5,0.2-1.6,2.9-1.6,2.9c0,0.1,0.1,0.1,0.3,0.2c0,0.1,0,0.1,0,0.1c0.1,0.4,2.4-0.1,3.3-0.2C48,56.2,48.2,56.2,48.2,56.2z"
              style="fill: #eee3e0"
            />
            <path
              d="M25.2,25.6c-3.3-1.1-7,0.6-8.1,4c-0.5,1.5-0.4,3,0.1,4.4c0.1,0.7,0.7,2,1.4,3.9
            c1,2.6,1.5,3.6,1.4,5.1c0,0.1,0,0.5,0,0.9c0,0,0,0,0,0c0,0.1,0,0.4,0,0.4c0,0,0,0.3,0,0.3c0,0,0,0.2,0.1,0.2c0,0,0.1,0.2,0.1,0.3
            c0,0,0.1,0.3,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.2,0.2,0.2c0,0,0.1,0.1,0.1,0.1c0.3,0.7,0.7,1.7,1.1,3.6
            c0.1,0.4,0.1,0.7,0.2,0.9c0,0,0,0,0,0c-0.1,0.2-0.2,0.3-0.2,0.5c0,0,0,0,0,0.1c0,0.1,0,0.2-0.1,0.2c0,0,0,0,0,0.1
            c0,0.1,0,0.2,0,0.2l0,0l-0.4,1.7c-2.4,0.1-1.6,2.8-1.6,2.8c0.1,0.5,3.7,0.1,4.3,0.1l1.4-1.4l1.3-0.8c0.7-0.6,0.5-1.5,0.2-1.9
            l-0.3-1l0,0c0-0.3,0-0.8,0.3-1.6c0.5-1.5-0.5-4.1-1.1-5.5c1-2.9,3.5-9.7,3.6-10.4c0,0,0,0,0,0C30.2,30.1,28.4,26.7,25.2,25.6z"
              style="fill: #eeedee"
            />
            <path
              d="M23.6,56.2L23.6,56.2c0-0.1-0.1-1-0.7-1.7c-0.6-0.6-1.3-0.9-1.4-0.9l-0.3-0.4
            c-2.5,0.1-1.6,2.9-1.6,2.9c0,0.1,0.1,0.1,0.3,0.2c0,0.1,0,0.1,0,0.1c0.1,0.4,2.4-0.1,3.3-0.2C23.4,56.2,23.5,56.2,23.6,56.2z"
              style="fill: #eee3e0"
            />
            <path
              d="M54.4,21.7c-0.6-0.6-0.8-2,0.1-3.1c1.1-1.3,2.4-1.5,1.8-2.5c-0.3-0.5-1.6-0.4-1.6-0.4
          s2.6-0.4,2.8,0.3c0.4,1.6,0.9,0.9,0.4,0c0,0,0.8,0.3,1,2.5c0.1,1-0.7,2.5-1.7,3.1C55.8,22.6,54.8,22.1,54.4,21.7z"
              class="yagi-tail"
              style="fill: #ffffff"
            />
            <path
              d="M28.3,35.3c0.8-3.3-1.2-6.6-4.5-7.6c-3.4-1-6.9,1-7.9,4.4c-0.4,1.5-0.3,3,0.3,4.3
            c0.1,0.7,0.8,2,1.6,3.8c1.2,2.5,1.7,3.5,1.7,5c0,0.1,0,0.5,0,0.9c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3
            c0,0.1,0,0.2,0,0.2c0,0.2,0.1,0.4,0.2,0.5c0,0,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0.1,0.1
            c0.1,0.1,0.1,0.2,0.2,0.2c0.4,0.7,0.8,1.7,1.1,3.6c0.1,0.4,0.2,0.7,0.2,0.9c0,0,0,0,0,0c0,0,0,0,0,0.1c-0.1,0.1-0.1,0.2-0.1,0.3
            c0,0,0,0.1,0,0.1c0,0.1-0.1,0.3-0.1,0.4l0,0l-0.5,1.7c-2.4,0-1.9,2.7-1.9,2.7c0.1,0.5,3.7,0.4,4.3,0.4l1.5-1.3l1.3-0.7
            c0.7-0.5,0.6-1.5,0.3-1.9l-0.2-1l0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.3,0-0.8,0.2-1.6c0.5-1.5-0.6-4.1-1.2-5.6
            C26.2,43,28.3,36.1,28.3,35.3C28.3,35.3,28.3,35.3,28.3,35.3z"
              style="fill: #ffffff"
            />
            <path
              d="M23.1,58.3L23.1,58.3c0-0.1,0-1.1-0.5-1.7c-0.5-0.7-1.3-1-1.3-1l-0.3-0.4c-2.5,0-1.9,2.7-1.9,2.7
            c0,0.1,0.1,0.2,0.3,0.2c0,0.1,0,0.1,0,0.1c0.1,0.4,2.4,0.1,3.3,0.1C22.9,58.3,23,58.3,23.1,58.3z"
              style="fill: #fbf5f5"
            />
            <path
              d="M53.7,37.9c0.2-1,1.9-5.2,2.3-6c1.3-2.4,1.7-5.8-0.4-8.2c-1.2-1.5-3-2.4-5-2.4
            c-0.3,0-0.6,0-0.9,0.1c-2.5,0.2-4.7,1.8-6.1,3.6c-0.8,1-5.2,8.9-4.6,12.7l0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1l0,0
            c0.2,1.1,0.6,2.1,1.3,3.1c3.1,4.1,4.9,4.3,6.3,6.8c0.1,0.2,0.2,0.4,0.3,0.6c0,0,0,0,0,0c1.3,3.2,0.3,4,0.6,4.7
            c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.3-0.1,0.4l-0.3,1.7c-2.4,0.2-1.6,2.8-1.6,2.8c0.2,0.5,3.7,0.1,4.3,0.1l1.4-1.4l1.3-0.8
            c0.7-0.6,0.5-1.5,0.2-1.9l-0.3-1l0,0c0-0.1-0.1-0.1-0.1-0.2c0.2-0.6,0.6-1.8,1.6-2.9c0.2-0.1,0.3-0.2,0.5-0.4
            c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1-0.1,0.1-0.1c0.8-0.9,1.3-2,1.3-3.2c0-0.7-0.1-1.3-0.4-1.9c0-0.1-0.1-0.2-0.1-0.3
            c-0.5-0.9-0.8-1.2-1.3-2.2c-0.6-1.2-0.7-2.5-0.5-3.6l0,0C53.7,38,53.7,38,53.7,37.9L53.7,37.9z"
              style="fill: #ffffff"
            />
            <path
              d="M49.5,58.4L49.5,58.4c0-0.1-0.1-1-0.7-1.7c-0.6-0.6-1.3-0.9-1.4-0.9l-0.3-0.4
            c-2.5,0.2-1.6,2.9-1.6,2.9c0,0.1,0.1,0.1,0.3,0.2c0,0.1,0,0.1,0,0.1c0.1,0.4,2.4-0.1,3.3-0.2C49.3,58.4,49.5,58.4,49.5,58.4z"
              style="fill: #fbf5f5"
            />
            <path
              d="M56.7,23.8c-1.4-2.9-4-4.7-6.8-5.7c-2.8-1-6.5,1.3-14.3,1.9c-1.3,0.1-4.9-0.8-5.3-0.9s-3.7-1.4-4-1.6
          c-5.1-2.3-9.3-5.7-9.3-5.7c-0.4-0.3-0.7-0.5-1.1-0.6c-0.8-0.5-1.6-0.7-2.6-0.7c-2.7,0-5,2.2-5,5c0,1.2,0.4,2.3,1.1,3.1
          c0.8,1.9,3.4,3.3,4.6,5.4c0.3,0.6,0.2,2.9,0.1,5c0,0,0,0,0,0c0,0.4-0.1,0.7-0.1,1.1c0,0,0,0,0,0c0,0.4,0,0.7,0,1.1c0,0,0,0,0,0
          c0,0.7,0.1,1.2,0.2,1.5c0,0,0,0,0,0c0.1,0.6,0.3,1.3,0.5,1.9c0,0,0,0.1,0,0.1c0.1,0.3,0.2,0.6,0.4,0.9c0,0,0,0.1,0,0.1
          c0.1,0.3,0.3,0.6,0.4,0.8c0,0,0,0,0,0c0.2,0.3,0.3,0.5,0.5,0.8c0,0,0,0.1,0.1,0.1c0.2,0.2,0.4,0.5,0.6,0.7c0,0,0.1,0.1,0.1,0.1
          c0.2,0.2,0.4,0.5,0.6,0.7c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.5,0.4,0.7,0.7c0.1,0,0.1,0.1,0.2,0.1l0,0c0.2,0.2,0.4,0.4,0.7,0.7
          c2.7,2.7,8.2,4.6,15.8,3.9c8.3-0.8,16.8-5,19.1-7.5C59.7,30.6,58,26.4,56.7,23.8z"
              :style="{ fill: yagi.profile.color }"
            />
            <path
              d="M8.6,18.8c-1,1.4-1.7,6-2.3,5.8s-1.3-1.4-1.2-3c0.1-1.5,1.1-4.6,2.3-4.4
          C8.1,17.3,9.4,17.8,8.6,18.8z"
              style="fill: #d11277"
            />
            <path
              d="M4.7,7.7C4.4,7.5,3.2,6.4,3.5,4.5C3.8,3.1,5.9,1.4,6.7,1c0.9-0.5,1.7-1,1.9-0.6
          c0.2,0.4,0.4,0.7,0.6,1.7c0.2,1,0.5,3.1-0.4,4.3c-0.6,0.9-1.5,1.4-2,1.5C6.1,8.1,5.2,8,4.7,7.7z"
              class="yagi-ear"
              :style="{ fill: yagi.profile.color }"
            />
            <path
              d="M21.6,12.4c-0.3-3.3-1.3-5-3.6-6.7C15.7,4,12.1,4.1,9.2,4.9C6.3,5.7,4.4,7.5,3.1,9.7s-1.4,4-1.2,5.6
          c0.2,1.6,1.3,2.7,1.3,2.7l0.5,0.4c0,0-2.2,0.3-2.9,2.2c-0.7,1.9,0.5,3.1,4.6,3.2c0.9,0,1.8,0,2.6-0.1c0,0.3,0.1,0.5,0.1,0.7
          c0,0.4-0.1,0.7-0.3,1.1c0,0-0.1,0.1-0.1,0.1s0.3,0,0.7-0.2c0.2-0.1,0.3,0,0,0.2c0,0,0.5-0.3,0.5-0.3c0.4-0.3,0.6-0.7,0.7-1.5
          c0-0.1,0-0.3,0-0.4c2.5-0.4,4.8-1.1,6.7-2.1C19.2,19.9,21.9,15.7,21.6,12.4z"
              style="fill: #ffffff"
            />
            <path
              d="M18,5.7c-0.9-0.7-2-1-3.2-1.2c-0.5-0.1-5.6,2.9-5.9,6.4c-0.4,3.7-1,7.9,3.3,7.8
          c3,0,6.6-1.1,8.7-2.4c0.6-1.3,0.9-2.6,0.7-3.8C21.3,9.1,20.3,7.4,18,5.7z"
              :style="{ fill: yagi.profile.color }"
            />
            <ellipse
              transform="matrix(0.9999 -1.387419e-02 1.387419e-02 0.9999 -0.2863 5.443924e-02)"
              cx="3.8"
              cy="20.7"
              rx="1.4"
              ry="1"
              style="fill: #eed0de"
            />
            <path
              d="M13.7,4.3c-0.1,0.5-0.5,0.9-1.1,0.8c-0.5-0.1-0.9-0.6-0.8-1.1c0.1-0.5,0.6-1.3,1.1-1.2
          C13.4,2.9,13.7,3.8,13.7,4.3z"
              style="fill: #1a2d78"
            />
            <path
              d="M9.1,4.4c0.2,0.5,0,1.1-0.5,1.3c-0.5,0.2-1,0-1.3-0.5S7.2,3.8,7.7,3.6C8.2,3.4,8.9,3.9,9.1,4.4z
          "
              style="fill: #1a2d78"
            />
            <path
              d="M6.2,17.7c0.1-0.5,0.8-3.5,0.3-6.5C6.2,9.6,5.3,8.4,4.6,7.7C4,8.3,3.5,9,3.1,9.7
          c-1.3,2.2-1.4,4-1.2,5.6c0.2,1.6,1.3,2.7,1.3,2.7l0.5,0.4c0,0,0.9-0.1,1.6,0.2C5.7,18.9,6.1,18.2,6.2,17.7z"
              :style="{ fill: yagi.profile.color }"
            />
            <path
              d="M17,6.8c-0.2-0.2-1.2-1.5,0.1-3.1c0.9-1.2,3.3-1.4,4.6-1.8s3.1-1.4,3.2-1.5
            c0.1-0.1,0.1-0.1,0.1-0.1s0.7,1.7,0,3.4c-0.6,1.4-1.5,2.9-3.8,3.7C18.9,8.3,17.7,7.7,17,6.8z"
              style="fill: #eee3e0"
            />
            <path
              d="M20.5,6.8c-0.1-0.2-0.4-0.1-0.4-0.1s0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2-0.1-0.2
            c-0.2,0-0.4,0.2-0.4,0.2S20.1,6,20,5.4c-0.1-0.5-0.7-0.1-1.4,0.4c0-0.1,0-0.2,0-0.2c-0.1,0-0.2,0-0.3,0.1c0,0,0-0.1-0.1-0.1
            c-0.2-0.1-0.6,0-0.8,0.4s-0.3,0.8,0,0.9C17.4,7,17.5,7,17.6,7c0,0.2,0.1,0.3,0.1,0.3L19,7.8c0,0,0.6-0.1,0.8-0.2
            c0.2-0.1,0.3,0.1,0.4-0.1c0.1-0.2-0.1-0.3,0-0.3C20.3,7.2,20.6,7,20.5,6.8z"
              style="fill: #eeedee"
            />
            <path
              d="M25.2,1.9C25.2,1.9,25.2,1.9,25.2,1.9C25.2,1.9,25.2,1.9,25.2,1.9c0-0.2,0-0.2,0-0.3
            c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.1-0.5-0.2-0.9-0.2-0.9s0,0-0.1,0.1
            c-0.1,0.1-1.9,1.1-3.2,1.5c-1.3,0.4-3.6,0.6-4.6,1.8c-0.5,0.6-0.6,1.2-0.6,1.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3
            c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0,0c0.1,0.1,0.1,0.3,0.2,0.4c0,0,0,0,0,0
            c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0.8,0.9,1.9,1.5,4.1,0.6c2.3-0.9,3.3-2.3,3.8-3.7
            C25.1,3.1,25.2,2.5,25.2,1.9z M21.1,7.2c-2,0.7-3.1,0.2-3.9-0.6c0-0.5,0.2-1,0.6-1.6c0.9-1.2,3.3-1.4,4.6-1.8
            c0.9-0.3,2.1-0.9,2.8-1.2c0,0.4-0.1,0.8-0.3,1.3C24.3,4.7,23.4,6.3,21.1,7.2z"
              style="fill: #ffffff"
            />
            <ellipse
              transform="matrix(0.9867 -0.1628 0.1628 0.9867 -2.5827 1.0227)"
              cx="4.9"
              cy="16.3"
              rx="0.5"
              ry="0.8"
              style="fill: #888888"
            />
            <ellipse
              transform="matrix(0.889 -0.458 0.458 0.889 -6.9259 4.0634)"
              cx="4.9"
              cy="16.3"
              rx="0.3"
              ry="0.2"
              style="fill: #1a2d78"
            />
            <circle cx="5" cy="16" r="0.2" style="fill: #f6f6f6" />
            <ellipse
              transform="matrix(0.9867 -0.1628 0.1628 0.9867 -2.345 2.1188)"
              cx="11.8"
              cy="15.4"
              rx="0.5"
              ry="0.8"
              style="fill: #888888"
            />
            <ellipse
              transform="matrix(0.4332 -0.9013 0.9013 0.4332 -7.247 19.3017)"
              cx="11.7"
              cy="15.4"
              rx="0.2"
              ry="0.3"
              style="fill: #1a2d78"
            />
            <circle cx="11.8" cy="15.1" r="0.2" style="fill: #f6f6f6" />
          </svg>
          <rt v-if="rubyEnabled">{{ yagi.profile.name }}</rt>
        </ruby>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  ref
} from 'vue'
import type { PropType } from 'vue'
import { useTimeoutFn } from '@vueuse/core'
import { emitter, emitOpenAccountDialog } from '@/plugins/emitter'

type YagiOptions = {
  dialogEnabled?: boolean
  rubyEnabled?: boolean
  messageEnabled?: boolean
  fixedMessage?: string
}

type YagiMessagePayload = {
  text?: unknown
  durationMs?: unknown
}

type YagiClient = {
  profile: {
    name: string
    color: string
  }
}

const props = defineProps({
  yagiOptions: {
    type: Object as PropType<YagiOptions>
  }
})

const yagi = (getCurrentInstance()!.proxy as unknown as { $yagi: YagiClient })
  .$yagi

const message = ref('')
const hideDelayMs = ref(3000)
const { start: startHideMessage, stop: stopHideMessage } = useTimeoutFn(
  () => {
    message.value = ''
  },
  hideDelayMs,
  { immediate: false }
)

function isOptionEnabled<T>(name: keyof YagiOptions, defaultValue: T): T {
  const options = props.yagiOptions
  if (options && Object.prototype.hasOwnProperty.call(options, name)) {
    return options[name] as T
  }
  return defaultValue
}

const dialogEnabled = computed(() => isOptionEnabled('dialogEnabled', true))
const rubyEnabled = computed(() => isOptionEnabled('rubyEnabled', true))
const messageEnabled = computed(() => isOptionEnabled('messageEnabled', false))
const fixedMessage = computed(() => isOptionEnabled('fixedMessage', ''))

function openDialog() {
  if (dialogEnabled.value) {
    emitOpenAccountDialog()
  }
}

function showMessage(nextMessage: unknown, durationMs?: unknown) {
  if (!messageEnabled.value) return
  message.value = String(nextMessage ?? '')
  hideDelayMs.value =
    typeof durationMs === 'number' && Number.isFinite(durationMs)
      ? durationMs
      : 3000
  stopHideMessage()
  startHideMessage()
}

function onYagiMessage(payload: unknown) {
  const body = payload as YagiMessagePayload | undefined
  showMessage(body?.text, body?.durationMs)
}

function networkChangeMessage(online: unknown) {
  if (online) {
    showMessage('つながった')
  } else {
    showMessage('オフラインになった')
  }
}

onBeforeMount(() => {
  emitter.on('yagi-message', onYagiMessage)
  emitter.on('network-changed', networkChangeMessage)
})

onBeforeUnmount(() => {
  emitter.off('yagi-message', onYagiMessage)
  emitter.off('network-changed', networkChangeMessage)
})
</script>
